import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

// Default fallback messages for authentication forms
// These ensure signin/signup work even before program translations load
const fallbackMessages = {
  en: {
    Email: "Email",
    Password: "Password",
    "Sign In": "Sign In",
    "Sign Up": "Sign Up",
    "Forgot Password": "Forgot Password",
    "Email is required": "Email is required",
    "Password is required": "Password is required",
    "Not a valid email": "Not a valid email",
    Closed: "Closed",
    "Send reset link by email": "Send reset link by email",
    "Back to Sign In": "Back to Sign In",
    "First Name": "First Name",
    "Last Name": "Last Name",
    "Confirm Password": "Confirm Password",
    "Passwords do not match": "Passwords do not match",
    "Terms and Conditions": "Terms and Conditions",
    "Privacy Policy": "Privacy Policy",
    "By signing in, you agree to the": "By signing in, you agree to the",
    "View our program": "View our program",
    "Loading...": "Loading...",
    Welcome: "Welcome",
    Home: "Home"
  },
  fr: {
    Email: "E-mail",
    Password: "Mot de passe",
    "Sign In": "Se connecter",
    "Sign Up": "S'inscrire",
    "Forgot Password": "Mot de passe oublié",
    "Email is required": "L'e-mail est requis",
    "Password is required": "Le mot de passe est requis",
    "Not a valid email": "E-mail non valide",
    Closed: "Fermé",
    "Send reset link by email":
      "Envoyer le lien de réinitialisation par e-mail",
    "Back to Sign In": "Retour à la connexion",
    "First Name": "Prénom",
    "Last Name": "Nom de famille",
    "Confirm Password": "Confirmer le mot de passe",
    "Passwords do not match": "Les mots de passe ne correspondent pas",
    "Terms and Conditions": "Termes et conditions",
    "Privacy Policy": "Politique de confidentialité",
    "By signing in, you agree to the": "En vous connectant, vous acceptez les",
    "View our program": "Voir notre programme",
    "Loading...": "Chargement...",
    Welcome: "Bienvenue",
    Home: "Accueil"
  }
};

const i18n = new VueI18n({
  locale: "en", // default locale
  fallbackLocale: "en",
  silentTranslationWarn: true,
  messages: fallbackMessages // Start with fallback messages
});

// Method to update translations dynamically
i18n.updateTranslations = function(translationData, locale = "en") {
  //console.log("🌐 Updating i18n translations for locale:", locale);
  //console.log("📝 Translation data keys:", Object.keys(translationData));

  // Merge with existing fallback messages to ensure auth forms always work
  const mergedMessages = {
    ...fallbackMessages[locale],
    ...translationData
  };

  // Set the messages for the locale
  this.setLocaleMessage(locale, mergedMessages);

  // Update current locale if it matches
  if (this.locale === locale || locale === "en") {
    this.locale = locale;
  }

  //console.log("✅ i18n translations updated successfully");
};

// Method to set locale with fallback
i18n.setLocaleWithFallback = function(locale) {
  //console.log("🌐 Setting i18n locale to:", locale);

  // Check if we have messages for this locale
  if (this.messages[locale]) {
    this.locale = locale;
    //console.log("✅ Locale set to:", locale);
  } else {
    //console.log("⚠️ No messages for locale:", locale, "falling back to en");
    this.locale = "en";
  }
};

export default i18n;
